import { Component, Input, OnInit } from '@angular/core';
import { HelpersService } from 'src/app/shared/services/helpers.service';
import { NavigationService } from 'src/app/shared/services/navigation.service';

@Component({
  selector: 'app-sample-card-convention',
  templateUrl: './sample-card-convention.component.html',
  styleUrls: ['./sample-card-convention.component.scss']
})
export class SampleCardConventionComponent implements OnInit {

  @Input() block: any;
  public stringTaxonomies: string = '';
  public isLinkEsternal: boolean = false;
  public objTitle = {
    title: '',
    hreflang: '',
    link: ''
  };

  constructor(
    private helperService: HelpersService,
    public navigationService: NavigationService
  ) { }

  ngOnInit(): void {
    this.setLabelTags();
    this.objTitle = this.helperService.retriveLinkTagA(this.block.field_titolo, "a");
    this.isLinkEsternal = this.objTitle.link ? this.helperService.verifyLinkExternal(this.objTitle.link) : false;
  }

  private setLabelTags() {
    let taxonomies: string[] = [];
    if (this.block.field_categoria_convenzione) {
      this.block.field_categoria_convenzione.forEach((taxonomy: any, idx: number) => {
        if (idx < 3) {
          taxonomies.push(taxonomy.name);
        }
      });
      if (this.block.field_categoria_convenzione.length > 3) {
        taxonomies.push(`+${this.block.field_categoria_convenzione.length - 3}`)
      }
    }
    this.stringTaxonomies = taxonomies.join(', ');
  }

}
